<template>
  <div id="choose-plan">
    <div
      class="header"
      v-if="showConvertDialog">
      <div
        class="title"
        @click="closeConvert">
        <span class="el-icon-arrow-left"></span><span>Back</span>
      </div>
    </div>
    <div
      class="header"
      v-else-if="!showPlanDetail && this.existPlan">
      <div
        class="title"
        @click="goBack">
        <span class="el-icon-arrow-left"></span><span>Choose a plan</span>
      </div>
    </div>

    <div v-if="showPlanDetail">
      <plan-detail
        :plan="planDetail"
        @reselect="reselect"
        :existPlan="existPlan"></plan-detail>
    </div>
    <div v-else-if="showConvertDialog">
      <div class="convert-dialog">
        <div class="current-plan">
          <div class="title">Current plan</div>
          <div class="charge-wrap">
            <p>Live source: <span class="value">{{ currentPlanInfo.liveSource }}</span></p>
            <p>Output: <span class="value">{{ currentPlanInfo.output }}</span></p>
            <p>Remaning time: <span class="value">{{ handleQuantity(currentPlanInfo.quantity) }}</span></p>
          </div>
        </div>
        <span class="el-icon-right"></span>
        <div class="convert-plan">
          <div class="title">Convert plan</div>
          <div class="charge-wrap">
            <p>Live source: <span class="convert-value">{{ convertPlanInfo.liveSource }}</span></p>
            <p>Output: <span class="convert-value">{{ convertPlanInfo.output }}</span></p>
            <p>Remaning time: <span class="convert-value">{{ handleQuantity(convertPlanInfo.quantity) }}</span></p>
          </div>
        </div>
      </div>
      <div class="plan-footer">
        <div
          class="choose no-choose"
          @click="handleClickConvert">Convert</div>
      </div>
    </div>
    <div
      class="plan-list"
      v-else>
      <plan-card
        :plan="item"
        v-for="item in planList"
        :key="item.id"
        @planchoose="planchoose"
        :existPlan="existPlan"></plan-card>
    </div>
    <!-- <transition name="fade" mode="in"  appear>
      <plan-detail v-if="showPlanDetail" :plan="planDetail" @reselect="reselect"></plan-detail>
    </transition> -->
  </div>
</template>

<script>
import PlanCard from './PlanCard.vue'
import PlanDetail from './PlanDetail.vue'
// import { mapState } from "vuex";
import { GET_NAMES } from '@/queries'
import { handleNewSub, queryPrice } from '@/common/checkuser.js'
import { Message } from 'element-ui'
export default {
  components: {
    PlanCard,
    PlanDetail
  },
  props: {
    existPlan: Object || null,
    from: String
  },
  inject: ['emailid', 'loadData'],
  data () {
    return {
      planList: [],
      planDetail: null,
      showPlanDetail: false,
      showConvertDialog: false,
      currentPlanInfo: {},
      convertPlanInfo: {}
    }
  },
  apollo: {
    plans: {
      query: GET_NAMES,
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
      credentials: true,
      variables () {
        return {
          customerId: this.emailid,
          product: 'Producer'
        }
      },
      result ({ data, loading, error }) {
        if (data) {
          console.log(data)
          const planList = data.plan.plans || []
          this.planDetail = planList[0]
          const chargeItems = planList[0].chargeItems
          const plans = [{ id: '4x', planId: planList[0].id }, { id: '8x', planId: planList[0].id }]
          plans.forEach(i => {
            const obj = this.createPlan(i.id)
            const output = chargeItems.find(j => j.addonId == obj.Output)
            obj.output = output.quantity
            Object.assign(i, obj)
          })
          console.log(chargeItems)
          // chargeItems.forEach(i => {
          //   plans.
          // })
          this.planList = plans
        }
        this.plansLoading = loading
        this.error = error
      }
    }
  },
  methods: {
    handleClickConvert () {
      this.handleCheckOut(this.convertPlanInfo.chargeItem)
    },
    closeConvert () {
      const dom = document.getElementById('producer')
      dom.style.minHeight = ''
      this.showConvertDialog = false
    },
    // 点击 buy
    handleCheckOut (chargeItem) {
      this.checkOutLoading = true
      // const planchargeItems = this.plan.chargeItems
      // const { InputNumber, TimeCredit } = this.handleAddOn(planchargeItems)
      // const quantity = Number(this.inputAddHours)
      // const chargeItems = {
      //   [InputNumber.addonId]: InputNumber.quantity,
      //   [TimeCredit.addonId]: quantity
      // }
      const params = {
        customerId: this.emailid,
        product: 'Producer',
        planId: this.existPlan.planId,
        chargeItems: JSON.stringify(chargeItem),
        description: `${this.existPlan.planName} ${this.emailid} checkoutSubscription`
      }
      handleNewSub(params, this).then((res) => {
        console.log(res)
        this.paySuccess = true
        this.checkOutLoading = false
        this.loadData()
      }).catch(err => {
        Message.error({
          message: err.info,
          duration: 5000
        })
        this.checkOutLoading = false
        if (err.type == 'REDIRECT') {
          // 跳到第三方页面， 添加监听页面切回来
          this.handlePayRedirect()
        }
      })
    },
    handlePayRedirect () {
      // 只需要监听一次
      const _this = this
      function visibilitychange () {
        if (!window.document.hidden) {
          console.log('visibilitychange')
          _this.loadData()
        }
      }
      window.document.addEventListener('visibilitychange', visibilitychange, { once: true })
    },
    handleAddOn (chargeItems) {
      let InputNumber = {}
      let TimeCredit = {}
      let Output = {}
      chargeItems.forEach(i => {
        if (i.addonId == 'producer-input-number') {
          InputNumber = i
        } else if (i.addonId == 'producer-time-credit') {
          TimeCredit = i
        } else if (i.addonId == 'producer-additional-output') {
          Output = i
        }
      })

      return { InputNumber, TimeCredit, Output }
    },
    // 选择一个PLAN
    // 修改： 先弹窗确认，然后支付后弹窗支付完成，之后再走这里的逻辑
    planchoose (params) {
      const { type, chargeItem, id } = params
      console.log(chargeItem)
      if (type == 'newPlan') {
        // this.handleCheckOut(chargeItem)
        const item = this.planList.find(i => i.id == id)
        this.planDetail = {
          ...item,
          ChargeItem: chargeItem
        }
        this.showPlanDetail = true
        this.$emit('titlechange', '')
      } else if (type == 'convertPlan') {
        // 先去转换时间
        const chargeItems = this.existPlan.chargeItems
        const { InputNumber, TimeCredit, Output } = this.handleAddOn(chargeItems)
        const currentChargeItems = {
          [InputNumber.addonId]: InputNumber.quantity,
          [TimeCredit.addonId]: 0,
          [Output.addonId]: Output.quantity
        }
        this.currentPlanInfo = {
          liveSource: InputNumber.quantity,
          output: Output.quantity
        }
        this.convertPlanInfo = {
          liveSource: chargeItem[InputNumber.addonId],
          output: chargeItem[Output.addonId],
          chargeItem
        }
        this.handleQueryPrice(currentChargeItems, 'current')
        this.handleQueryPrice(chargeItem, 'convert')

        this.showConvertDialog = true
        const dom = document.getElementById('producer')
        dom.style.minHeight = 'unset'
      }
    },
    getPlanList () {
      // const params = {

      // }
    },
    createPlan (id) {
      if (id === '4x') {
        return {
          background: 'linear-gradient(274.86deg, #BDCFF4 0%, #E6EDFA 100%)',
          color: 'var(--dialog-input-color)',
          priceColor: '#252525',
          fakePlanName: '4× Input Producer',
          input: 4,
          // output: 3,
          Number: 'producer-input-number',
          Credit: 'producer-time-credit',
          Output: 'producer-additional-output',
          price: '35'
        }
      } else if (id === '8x') {
        return {
          background: 'linear-gradient(274.86deg, #E7AA4D 0%, #FFF4D3 100%)',
          color: '#33AB4F',
          priceColor: '#33AB4F',
          fakePlanName: '8× Input Producer',
          input: 8,
          // output: 6,
          Number: 'producer-input-number',
          Credit: 'producer-time-credit',
          Output: 'producer-additional-output',
          price: '70'
        }
      }
    },
    // choose plan 操作完成后
    planchooseDone (id) {
      console.log(id)
      const item = this.planList.find(i => i.id == id)
      console.log(item)
      if (!item) return
      if (this.from == 'dashboard') {
        this.$emit('choose', item)
      } else {
        // 到plan detail页面
        this.showPlanDetail = true
        this.$emit('titlechange', '')
        this.planDetail = item
      }
    },
    // 返回上一级
    reselect () {
      this.showPlanDetail = false
      this.planDetail = null
      if (this.existPlan) {
        this.$emit('titlechange', '')
      } else {
        this.$emit('titlechange', 'Choose a plan')
      }
    },
    goBack () {
      this.$emit('reselectPlan', true)
    },
    // 处理quantity s
    handleQuantity (value) {
      if (!value || value == 0 || isNaN(value)) {
        return '0h 00min'
      } else {
        let abs = ''
        if (value < 0) {
          abs = '-'
          value = Math.abs(value)
        }
        value = value / 60
        const hour = Math.floor(value / 60)
        let min = Math.ceil(value % 60)
        min = min < 10 ? '0' + min : min
        return `${abs} ${hour}h ${min}min`
      }
    },
    // 查询价格
    handleQueryPrice (chargeItems, type) {
      const params = {
        customerId: this.emailid,
        product: 'Producer',
        planId: this.existPlan.planId,
        chargeItems: JSON.stringify(chargeItems)
      }

      queryPrice(params).then(({ data }) => {
        if (data.previewCustomSubscription) {
          if (type == 'current') {
            this.currentPlanInfo.quantity = Number(data.previewCustomSubscription.quantity)
          } else {
            this.convertPlanInfo.quantity = Number(data.previewCustomSubscription.quantity)
          }
          this.$forceUpdate()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
#choose-plan {
  // width: 600px;
  position: relative;
  .plan-list {
    display: flex;
  }
  .header {
      position: absolute;
      width: 50%;
      top: -60px;

      .title {
        line-height: 24px;
        font-weight: 700;
        font-size: 18px;
        // color: #303133;
        cursor: pointer;
      }
      .el-icon-arrow-left {
        font-weight: 900;
      }
  }
  .convert-dialog {
    display: flex;
    align-items: center;
    text-align: left;
    justify-content: space-between;
    // padding-top: 20px;
    .title {
      color: var(--dialog-input-color);
      font-size: 24px;
      margin: 40px 0;
    }
    .el-icon-right {
      font-size: 24px;
      color: var(--dialog-input-color);
      margin-top: 40px;
    }
    .charge-wrap {
      margin: 5px 0;
      color: var(--dialog-text-info-color);
      .value {
        color: var(--dialog-input-color);
      }
      .convert-value {
        color: #33AB4F;
      }
      p {
        margin: 5px 0;
      }
    }
  }
  .plan-footer {
    height: 60px;
    margin-top: 50px;
    .choose {
      border: 1px solid #33AB4F;
      color: var(--dialog-input-color);
      width: fit-content;
      max-width: 200px;
      height: 16px;
      line-height: 16px;
      padding: 10px 8px;
      text-align: center;
      border-radius: 5px;
      margin: 0 auto;
      cursor: pointer;
      transition: all .3s;
      user-select: none;
      background: #33AB4F;
    }
  }
}
</style>
